import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { PromotionTitle } from './promotionDetails.action';

const initialState: PromotionTitle = {
	description: '',
	imageAltText: '',
	imageUrl: '',
	promotionId: '',
	title: '',
	dateTill: '',
	isTimed: false,
	primaryButton: {
		link: '',
		text: '',
	},
};

const reducer = (state: PromotionTitle = initialState, action: Action): PromotionTitle => {
	switch (action.type) {
		case actionTypes.FETCH_PROMOTION_NAME_SUCCESS:
			return {
				...state,
				title: action.payload.promoDetails.title,
				promotionId: action.payload.promoDetails.promotionId,
				imageUrl: action.payload.promoDetails.imageUrl,
				imageAltText: action.payload.promoDetails.imageAltText,
				description: action.payload.promoDetails.description,
				dateTill: action.payload.promoDetails.dateTill,
				isTimed: action.payload.promoDetails.isTimed,
			};
		default:
			return state;
	}
};

export default reducer;
